import { render, staticRenderFns } from "./GzhCodeView.vue?vue&type=template&id=964997ba&scoped=true"
import script from "./GzhCodeView.vue?vue&type=script&lang=js"
export * from "./GzhCodeView.vue?vue&type=script&lang=js"
import style0 from "./GzhCodeView.vue?vue&type=style&index=0&id=964997ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964997ba",
  null
  
)

export default component.exports